import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import Stats from './components/Stats';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Team from './components/Team';
import About from './components/About';
import Testimonials from './components/Testimonials';
import InstagramFeed from './components/InstagramFeed';
import Location from './components/Location';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Preloader from './components/Preloader';
import SEOSchema from './components/SEOSchema';

function App() {
  return (
    <div className="App" id="inicio">
      <SEOSchema />
      <Preloader />
      <Header />
      <Hero />
      <TrustBadges />
      <Services />
      <Stats />
      <HowItWorks />
      <Team />
      <About />
      <Testimonials />
      <InstagramFeed />
      <Location />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;